import cloneDeep from 'lodash.clonedeep';

import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const updateSensitivePropertyGroupIris =
  (prevIri: string, newIri: string) => (model: Model) => {
    const sensitivePropertyGroups = cloneDeep(
      model.modelData.sensitivePropertyGroupsByName
    );
    Object.entries(sensitivePropertyGroups).forEach(
      ([groupName, groupIris]) => {
        if (groupIris.includes(prevIri)) {
          const newGroupIris = groupIris.filter((iri) => iri !== prevIri);
          newGroupIris.push(newIri);
          sensitivePropertyGroups[groupName] = newGroupIris;
        }
      }
    );

    setDataProperty<ModelData>(model)(
      model.modelData,
      'sensitivePropertyGroupsByName',
      sensitivePropertyGroups
    );
  };
